import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  title: "Venus 3D Creations — Sculptural 3D-Printed Lamps & Studio Objects",
  description:
    "Handcrafted 3D-printed lamps, sculptures and home objects — made to order in our Ahmedabad studio. Complimentary shipping across India over ₹2,500.",
  image: "https://venus3dcreations.com/og-default.jpg",
  type: "website",
};

/**
 * Per-page SEO + Open Graph. Use on every top-level page.
 * Falls back to studio defaults if a field is omitted.
 */
const SEO = ({ title, description, image, type, url, noIndex = false }) => {
  const t = title ? `${title} — Venus 3D Creations` : DEFAULTS.title;
  const d = description || DEFAULTS.description;
  const img = image || DEFAULTS.image;
  const u = url || (typeof window !== "undefined" ? window.location.href : "https://venus3dcreations.com");
  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={u} />
      {/* Open Graph */}
      <meta property="og:site_name" content="Venus 3D Creations" />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:type" content={type || DEFAULTS.type} />
      <meta property="og:url" content={u} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default SEO;
